import { render, staticRenderFns } from "./ResolutionEdit.vue?vue&type=template&id=3884e2fb&scoped=true&"
import script from "./ResolutionEdit.vue?vue&type=script&lang=js&"
export * from "./ResolutionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionEdit.vue?vue&type=style&index=0&id=3884e2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884e2fb",
  null
  
)

export default component.exports